// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./Components/Navbar";
import Header from "./Components/Header";
import ScrollToTop from "./Components/ScrollToTop";
import Home from "./Components/Home";
import Footer from "./Components/Footer";
import Recruiters from "./Components/Recruiters";
import CoursesSection from "./Components/CourseSection";
import ContactUs from "./Components/ContactUs";
import Gallery from "./Components/Gallery";
import Admin from "./Admin/Admin";
import AboutUs from "./Components/AboutUs";
import CoursePage from "./Components/CoursePage"; // Ensure this path is correct
function App() {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <Navbar/>
      <Routes>
        <Route
          path="/"
          element={
            <>   
              <Home/>
              <CoursesSection/>
              <ContactUs/>
              <Recruiters/>
              <Footer/>
            </>
          }
        />
        <Route path="/gallery" element={<Gallery/>}/>        
        <Route path="/admin" element={<Admin/>}/>
        <Route path="/about" element={<AboutUs/>} />
        <Route path="/coursePage" element={<CoursePage/>}/>
      </Routes>
    </Router>
  );
}

export default App;
